import PropTypes from 'prop-types';
import React from 'react';
import { Pagination } from 'react-bootstrap';
import ReactTable from 'react-table';
import { Button } from 'react-bootstrap';
import { LazySelect } from '../ReactProtos/CellSelect';

function formatError(error) {
    if (typeof error === 'object') {
        return <pre style={{ color: 'red' }}>{JSON.stringify(error, null, 4)}</pre>;
    } else {
        return <div style={{ color: 'red' }}>{error}</div>;
    }
}
class DeadlineEditor extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            hide: false,
            value: '',
            error: '',
        };
    }
    componentDidMount() {
        this.loadMeta();
    }

    async loadMeta() {
        const response = await fetch('/api/data/search/leader_board_meta', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    _id: this.props.type,
                },
            }),
        });
        const result = await response.json();
        if (result.results.length === 0) {
            this.setState({loading: false, hide: true});
        } else {
            this.setState({ loading: false, value: result.results[0].deadline, error: '' });
        }
    }

    handleValue = e => {
        this.setState({ value: e.target.value });
    }

    handleSet = async () => {
        try {
            const deadline = new Date(this.state.value).toISOString();
            await fetch('/api/data/update/leader_board_meta', {
                method: 'post',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    query: {
                        _id: this.props.type,
                    },
                    update: {
                        $set: { deadline },
                    },
                }),
            });
            this.setState({ loading: true }, () => this.loadMeta());
        } catch (err) {
            console.error(err);
            this.setState({error: err.toString()});
        }
    }

    render() {
        if (this.state.loading) {
            return 'Loading...';
        }
        if (this.state.hide) {
            return null;
        }
        return (
            <div>
                score submission deadline:
                <input style={{width: '200px'}} value={this.state.value} onChange={this.handleValue} />
                <Button onClick={this.handleSet}>Set</Button>
                {
                    this.state.error && formatError(this.state.error)
                }
            </div>
        )
    }
}

DeadlineEditor.propTypes = {
    type: PropTypes.string.isRequired,
};

export class LeaderBoard extends React.PureComponent {
    static getLeaderBoardColumns(currentGroup, updateGroup) {
        return [
            {
                Header: "Rank",
                accessor: 'rank',
                Cell: row => (<div>{row.value}</div>),
                width: 50,
            },
            {
                Header: 'Id',
                accessor: 'uuid',
                Cell: row => (<a style={{ backgroundColor: row.original.highlight ? 'red' : null }} href={`/user/${row.value}#%7B"user"%3A%7B"tab"%3A11%7D%7D`}>{row.value}</a>),
                width: 350,
            },
            {
                Header: 'Score',
                accessor: 'score',
                width: 100,
            },
            {
                Header: 'Payload',
                accessor: 'payload',
                width: 150,
            },
            {
                Header: 'Time',
                accessor: 'seconds_since_unit_epoch',
                Cell: row => new Date(row.value * 1000).toLocaleString(),
                width: 150,
            },
            {
                Header: 'Operation',
                id: 'operation',
                Cell: row => {
                    return <Button onClick={() => updateGroup(row.original._id, 1 - row.original.group)}>
                        {currentGroup === 0 ? "Mark Cheater" : "Unmark Cheater"}
                    </Button>;
                },
            }
        ];
    }

    state = {
        group: 0,
        users: null,
        types: null,
        type: window.localStorage.getItem('leaderboard'),
        uuid: window.localStorage.getItem('leaderboard_uuid') ?? '',
    };

    componentDidMount() {
        this.fetchLeaderBoardTypes();
    }

    async fetchLeaderBoardTypes() {
        const response = await fetch('/api/data/aggregate/leader_board', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [{
                    $group: {
                        _id: "$type",
                    }
                }],
            }),
        });
        const result = await response.json();
        this.setState({ types: result.results.map(result => result._id) });
        if (this.state.type != null && !this.state.users) {
            this.fetchLeaderBoard();
        }
    }

    async fetchLeaderBoard() {
        if (this.state.uuid) {
            await this.fetchSurroundingLeaderBoard(this.state.uuid);
        } else {
            await this.fetchTopLeaderBoard();
        }
    }
    async fetchTopLeaderBoard() {
        const response = await fetch('/api/data/search/leader_board', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    type: this.state.type,
                    group: this.state.group,
                },
                sort: {
                    score: -1,
                },
            }),
        });
        const result = await response.json();
        for (let i = 0; i < result.results.length; i++) {
            result.results[i].rank = i + 1;
        }
        this.setState({ users: result.results });
    }
    async fetchSurroundingLeaderBoard(uuid) {
        const scoreResponse = await fetch('/api/data/search/leader_board', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    type: this.state.type,
                    group: this.state.group,
                    uuid,
                },
            }),
        });
        const scoreResult = await scoreResponse.json();
        if (scoreResult.results.length === 0) {
            this.setState({ users: [] });
            return;
        }
        const record = scoreResult.results[0];

        const beforeResponse = await fetch('/api/data/search/leader_board', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    type: this.state.type,
                    group: this.state.group,
                    score: { $gte: record.score },
                },
                sort: {
                    score: 1,
                },
                limit: 10,
            }),
        });
        const beforeResult = await beforeResponse.json();
        const afterResponse = await fetch('/api/data/search/leader_board', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                query: {
                    type: this.state.type,
                    group: this.state.group,
                    score: { $lt: record.score },
                },
                sort: {
                    score: -1,
                },
                limit: 25,
            }),
        });
        const afterResult = await afterResponse.json();
        const countResponse = await fetch('/api/data/aggregate/leader_board', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                pipeline: [{
                    $match: {
                        type: this.state.type,
                        group: this.state.group,
                        score: { $gte: record.score }
                    }
                }, {
                    $count: "count"
                }],
            }),
        });
        const countResult = await countResponse.json();
        const rank = countResult.results[0].count;
        for (let i = 0; i < beforeResult.results.length; i++) {
            beforeResult.results[i].rank = rank - i;
        }
        beforeResult.results[0].highlight = true;
        for (let i = 0; i < afterResult.results.length; i++) {
            afterResult.results[i].rank = rank + 1 + i;
        }
        this.setState({ users: beforeResult.results.reverse().concat(afterResult.results) });
    }

    selectGroup = group => () => {
        this.setState({ group, users: null }, () => this.fetchLeaderBoard());
    }

    updateGroup = async (id, group) => {
        await fetch('/api/leader_board/update_group', {
            method: 'post',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                id,
                group,
            }),
        });
        this.setState({ users: null }, () => this.fetchLeaderBoard());
    }

    handleType = value => {
        window.localStorage.setItem('leaderboard', value.value);
        this.setState({ type: value.value, users: null }, () => this.fetchLeaderBoard());
    }

    handleUuid = e => {
        const value = e.target.value.trim();
        window.localStorage.setItem('leaderboard_uuid', value);
        this.setState({ uuid: value });
    }

    handleRefresh = () => {
        this.setState({ users: null }, () => this.fetchLeaderBoard());
    }

    render() {
        window.users = this.state.users;
        if (!this.state.types) {
            return "Loading leaderboard types...";
        }
        return (
            <div>
                <div style={{ display: 'flex' }}>
                    Leaderboard:
                    <div style={{ width: '25vw' }} >
                        <LazySelect value={{ value: this.state.type, label: this.state.type ?? '<not selected>' }} options={this.state.types.map(type => ({ value: type, label: type }))} onChange={this.handleType} />
                    </div>
                    {
                        this.state.type &&
                        <DeadlineEditor type={this.state.type} key={this.state.type} />
                    }
                </div>
                <div style={{ display: 'flex' }}>
                    <Pagination>
                        <Pagination.Item active={this.state.group === 0} onClick={this.selectGroup(0)}>
                            Regular
                        </Pagination.Item>
                        <Pagination.Item active={this.state.group === 1} onClick={this.selectGroup(1)}>
                            Cheater
                        </Pagination.Item>
                    </Pagination>
                    <div>
                        uuid: <input style={{ width: '25vw' }} type="text" value={this.state.uuid} onChange={this.handleUuid} />
                    </div>
                    <Button onClick={this.handleRefresh}>Refresh</Button>
                </div>
                {
                    this.state.users && this.state.users.length === 0 &&
                    "No result found"
                }
                {
                    this.state.users && this.state.users.length > 0 &&
                    <ReactTable
                        data={this.state.users}
                        columns={LeaderBoard.getLeaderBoardColumns(this.state.group, this.updateGroup)}
                        pageSize={this.state.users.length}
                        showPagination={false}
                    />
                }
                {
                    !this.state.users &&
                    "Loading..."
                }
            </div>
        );
    }
}
